import api from '@/services/api'
import axios from '@/services/axios'
import constants from '@/services/constants/config'
import request from '@/services/request'
import utils from '@/services/utils/config'
import { v4 as uuidv4 } from 'uuid'
import Cookies from 'js-cookie'
import WorldJson from '@/assets/world.json' // 世界地图json
import sensors from '@/trace/index.js'
import store from '@/store'

import dayjs from 'dayjs'
const utc = require('dayjs/plugin/utc')
const quarterOfYear = require('dayjs/plugin/quarterOfYear')
const isoWeek = require('dayjs/plugin/isoWeek')
const relativeTime = require('dayjs/plugin/relativeTime')
dayjs.extend(utc)
dayjs.extend(quarterOfYear)
dayjs.extend(isoWeek)
dayjs.extend(relativeTime)

const echarts = require('echarts/lib/echarts')
require('echarts/lib/chart/bar')
require('echarts/lib/chart/line')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/map')
require('echarts/lib/chart/scatter')
require('echarts/lib/chart/effectScatter')
require('echarts/lib/chart/treemap')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/grid')
require('echarts/lib/component/legend')
require('echarts/lib/component/markLine')
require('echarts/lib/component/graphic')
require('echarts/lib/component/dataZoom')
require('echarts/lib/component/markPoint')
require('echarts/lib/component/visualMap')
require('echarts/lib/component/visualMap')
require('echarts/lib/component/markArea')
echarts.registerMap('world', WorldJson)

const elementResizeDetectorMaker = require('element-resize-detector') // dom元素变化监听

function inject(Vue, name, module) {
  Object.defineProperty(Vue.prototype, name, {
    get() {
      return module
    }
  })
}

export default {
  install(Vue) {
    inject(Vue, '$axios', axios)
    inject(Vue, '$request', request)
    inject(Vue, '$api', api)
    inject(Vue, '$constants', constants)
    inject(Vue, '$utils', utils)
    inject(Vue, '$idV4', uuidv4)
    inject(Vue, '$dayjs', dayjs)
    inject(Vue, '$echarts', echarts)
    inject(Vue, '$cookie', Cookies)
    inject(Vue, '$erd', elementResizeDetectorMaker)
    inject(Vue, '$sensors', sensors)
    inject(Vue, '$cTime', () => {
      return dayjs().add(store.state.map.utcTimeOffset, 'ms')
    })
  }
}
